export { default } from './InfoText';
